import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('SsoLogoutApp => ');

const onRedirectRequest = createAction('redirect request');
const onRedirectSuccess = createAction('redirect request success');
const onRedirectFailure = createAction('redirect request failure');

export default {
  onRedirectRequest,
  onRedirectSuccess,
  onRedirectFailure,
};
